export default __webpack_public_path__ + "static/media/doDetails.c8dac977.svg";